var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1306_12228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0C8.97554 0.00174378 7.51402 0.608106 6.43606 1.68606C5.35811 2.76402 4.75174 4.22554 4.75 5.75C4.75 6.13125 4.90145 6.49688 5.17103 6.76647C5.44062 7.03605 5.80625 7.1875 6.1875 7.1875C6.56875 7.1875 6.93438 7.03605 7.20397 6.76647C7.47355 6.49688 7.625 6.13125 7.625 5.75C7.625 4.9875 7.9279 4.25623 8.46707 3.71707C9.00623 3.1779 9.7375 2.875 10.5 2.875C11.2625 2.875 11.9938 3.1779 12.5329 3.71707C13.0721 4.25623 13.375 4.9875 13.375 5.75C13.375 6.99658 12.6422 7.76166 11.4378 8.87347C10.3231 9.89958 9.0625 11.062 9.0625 12.9375C9.0625 13.3187 9.21395 13.6844 9.48353 13.954C9.75312 14.2235 10.1188 14.375 10.5 14.375C10.8812 14.375 11.2469 14.2235 11.5165 13.954C11.786 13.6844 11.9375 13.3187 11.9375 12.9375C11.9375 12.3521 12.4878 11.8145 13.3862 10.9862C14.5935 9.87158 16.25 8.34564 16.25 5.75C16.2483 4.22554 15.6419 2.76402 14.5639 1.68606C13.486 0.608106 12.0245 0.00174378 10.5 0Z",
    fill: "#00406A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 17.25C9.93138 17.25 9.37553 17.4186 8.90274 17.7345C8.42995 18.0504 8.06145 18.4994 7.84385 19.0248C7.62625 19.5501 7.56931 20.1282 7.68024 20.6859C7.79118 21.2436 8.06499 21.7559 8.46707 22.1579C8.86915 22.56 9.38142 22.8338 9.93912 22.9448C10.4968 23.0557 11.0749 22.9988 11.6002 22.7812C12.1256 22.5636 12.5746 22.1951 12.8905 21.7223C13.2064 21.2495 13.375 20.6936 13.375 20.125C13.3742 19.3627 13.0711 18.6319 12.5321 18.0929C11.9931 17.5539 11.2623 17.2508 10.5 17.25Z",
    fill: "#00406A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1306_12228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqTab);
export default __webpack_public_path__ + "static/media/faqTab.f2397585620fa2648cfab1ba8ed91fbe.svg";
export { ForwardRef as ReactComponent };